import React, { Fragment, useContext, useEffect, useState } from "react";
import { _O } from "../../modules/utils";
import { ScrollToTop } from "../common/ScrollToTop/ScrollToTop";
import { Container, DateLayer } from "../Layout";
import { SubMenu } from "./ProofApply";

export default () => {
    // 다운로드 이벤트 추가
    const claim = () => {
        _O.Open("/proof/insurance");
    }
    return (
        <Fragment>
            <ScrollToTop />
            <Container Title="보험청구" proof="CLAIM" onClick={()=>claim()}>
                <div className="contents sub grad">
                    <SubMenu code="APPLY" />

                    <div className="sub-contents">
                        <div className="steps-bar-area">
                            <ul>
                                <li><a>STEP 1</a></li>
                                <li><a>STEP 2</a></li>
                                <li><a>STEP 3</a></li>
                                <li className="on"><a>STEP 4</a></li>
                            </ul>
                        </div>

                        <div className="sub-title">6. 보험청구 방법을 선택하세요.</div>
                        <div className="device-state-info">
                            한번등록한 이메일은 자동 저장됩니다.
                        </div>

                        <div className="check-bar-area">
                            <ul>
                                <li>
                                    <label>
                                        <input type="checkbox" className="inp-select-check" />
                                        <div>
                                            이메일	 <i></i>
                                        </div>
                                    </label>
                                    <div className="inp-box">
                                        <input type="text" className="textbox gray" placeholder="이메일을 입력해 주세요." />
                                    </div>
                                </li>
                                <li>
                                    <label>
                                        <input type="checkbox" className="inp-select-check" />
                                        <div>
                                            팩스	 <i></i>
                                        </div>
                                    </label>
                                    <div className="inp-box">
                                        <input type="text" className="textbox gray" placeholder="팩스번호를 입력해 주세요." />
                                    </div>
                                </li>
                                <li>
                                    <label>
                                        <input type="checkbox" className="inp-select-check" />
                                        <div>
                                            보험회사 앱	 <i></i>
                                        </div>
                                    </label>
                                </li>
                            </ul>
                        </div>
                    </div>	
                </div>
            </Container>
        </Fragment>
    );
}